import { render, staticRenderFns } from "./SearchStudy.vue?vue&type=template&id=10ddf7fa&scoped=true&lang=pug"
import script from "./SearchStudy.vue?vue&type=script&lang=ts"
export * from "./SearchStudy.vue?vue&type=script&lang=ts"
import style0 from "./SearchStudy.vue?vue&type=style&index=0&id=10ddf7fa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ddf7fa",
  null
  
)

export default component.exports